
export interface ZonicModel {
    id: number;
    name: string;
    url:string;
    usdz?:string;
    factName?:string;
    fact?:string;
    facts?: any;
    accordionFacts?: any;
    animationName?: string;
    animatioDuration?: number;
    animatioDurationEnd?: number;
}
interface ZONIC_MODELS_CONFIGURATION  {
    groupname: string;
    models: ZonicModel[];
}


const commmonZonicAccordionFacts = {
    "Exklusives Spielgefühl": [
        "Perfekter Blickwinkel auf die Monitore",
        "Fließender Übergang zwischen Monitoren und Pult",
        "Eingehauste Monitore bei fast alle Frames, wodurch der Spielgast in eine eigene Welt eintaucht",
    ],
    "Frame-Konzept": [
        "Individueller Look durch verschiedene Frames",
        "Einfacher Frame-Wechsel ermöglicht die schnelle Veränderung des ZONIC-Looks",
    ],
    "Lichtkonzept": [
        "Umlaufender Lichtschlauch",
        "Rainbow-Technologie",
    ],
    "Neues Tasten-Konzept": [
        "Große Starttasten",
        "Perfekte Anordnung",
        "Schutz der Tastenelektronik vor Flüssigkeit",
    ],
    "HR-Cash Geldmanagement": [
        "Alle angenommenen Münzsorten werden ausgezahlt",
        "Reine Banknoten-Kassierung durch intelligente Auszahlsteuerung",
    ],
    "Exklusive Power Spin Spiele": [
        "Fruitinator Power Spins",
        "Gold Cup Power Spins",
        "Joker’s Cap Power Spins",
    ]
}

export const BASE = "/assets/models"

export const ZONIC_MODELS:ZONIC_MODELS_CONFIGURATION[] = [
    {
        groupname: "Standard-Modelle",
        models:[
            {
                name: "PURE", id:1,
                url: `${BASE}/zonic/Pure/Single_Pure.glb`,
                usdz: `${BASE}/zonic/Pure/Single_Pure.usdz`,
                factName: "PURE",
                facts: {
                    "Abmessung": "H: 175 cm, B:  82 cm, T:  86 cm",
                    "Gewicht": "205kg",
                },
                accordionFacts: commmonZonicAccordionFacts,
                animationName: "Single_Pure_Anim_0",
                animatioDuration: 800,
                animatioDurationEnd: 800,
            },
            {
                name: "LINE", id:2,
                url: `${BASE}/zonic/Line/Single_Line.glb`,
                usdz: `${BASE}/zonic/Line/Single_Line.usdz`,
                factName: "LINE",
                facts: {
                    "Abmessung": "H: 175 cm, B:  81 cm, T:  92 cm",
                    "Gewicht": "203kg",
                },
                accordionFacts: commmonZonicAccordionFacts,
                animationName: "Single_Line_Anim_0",
                animatioDuration: 800,
                animatioDurationEnd: 800,
            },
            {
                name: "FLASH", id:3,
                url: `${BASE}/zonic/Blau/Single_Blue.glb`,
                usdz: `${BASE}/zonic/Blau/Single_Blue.usdz`,
                facts: {
                    "Abmessung": "H: 175 cm, B:  83 cm, T:  86 cm",
                    "Gewicht": "204kg",
                },
                factName: "FLASH",
                accordionFacts: commmonZonicAccordionFacts,
                animationName: "single_blue_Anim_0",
                animatioDuration: 1000,
                animatioDurationEnd: 800,
            },
            {
                name: "FLEX", id:4,
                url: `${BASE}/zonic/Flex/Single_Flex.glb`,
                usdz: `${BASE}/zonic/Flex/Single_Flex.usdz`,
                factName: "FLEX",
                facts: {
                    "Abmessung": "H: 175 cm, B:  83 cm, T:  91 cm",
                    "Gewicht": "207kg",
                },
                accordionFacts: commmonZonicAccordionFacts,
                animationName: "single_flex_Anim_0",
                animatioDuration: 800,
                animatioDurationEnd: 800,
            },
            {
                name: "VADER", id:5,
                url: `${BASE}/zonic/Vader/Single_Vader.glb`,
                usdz: `${BASE}/zonic/Vader/Single_Vader.usdz`,
                factName: "VADER",
                facts: {
                    "Abmessung": "H: 175 cm, B:  117 cm, T:  86 cm",
                    "Gewicht": "213kg",
                },
                accordionFacts: commmonZonicAccordionFacts,
                animationName: "Single_Vader_Anim_0",
                animatioDuration: 800,
                animatioDurationEnd: 800,
            },
            {
                name: "DIAMOND", id:6,
                url: `${BASE}/zonic/Diamond/Single_Diamond.glb`,
                usdz: `${BASE}/zonic/Diamond/Single_Diamond.usdz`,
                factName: "DIAMOND",
                facts: {
                    "Abmessung": "H: 175 cm, B:  121 cm, T:  92 cm",
                    "Gewicht": "224kg",
                },
                fact: "Exklusiv in der ZONIC Zone",
                accordionFacts: {
                    "Spielbereiche mit besonderer Ausstattung": [
                        "Gold Spielepaket",
                        "Diamond Frames",
                        "Zonic Zeat Zone",
                        "Leuchtwände",
                        "Teppich",
                    ],
                    ...commmonZonicAccordionFacts,
                },
                animationName: "Diamond_Anim_0",
                animatioDuration: 800,
                animatioDurationEnd: 800,
            },
            // {
            //     name: "Flash Blue", id:1,
            //     url: `${BASE}/zonic/Blau/Single_Blue.glb`,
            //     usdz: `${BASE}/zonic/Blau/Single_Blue.glb`
            //     factName: "FLASH",
            //     facts: {
            //         "Abmessung": "H: 175 cm, B:  83 cm, T:  86 cm",
            //         "Gewicht": "204kg",
            //     },
            //     accordionFacts: commmonZonicAccordionFacts,
            //     animationName: "single_blue_Anim_0",
            //     animatioDuration: 1000,
            //     animatioDurationEnd: 800,
            // },

            

        ]
    },
    {
        groupname: "Duo-Modelle",
        models:[
            {
                name: "FLASH DUO", id:7,
                url: `${BASE}/zonic/Duo_Red/Duo_Red.glb`,
                usdz: `${BASE}/zonic/Duo_Red/Duo_Red.usdz`,
                factName: "FLASH DUO",
                facts: {
                    "Abmessung": "H: 179 cm, B:  83 cm, T:  184 cm",
                    "Gewicht": "434kg",
                },
                accordionFacts: commmonZonicAccordionFacts,
                animationName: "Duo_Blau_Anim_0",
                animatioDuration: 1100,
                animatioDurationEnd: 800,
            },
            {
                name: "FLEX DUO", id:8,
                url: `${BASE}/zonic/Duo_Flex/Duo_Flex.glb`,
                usdz: `${BASE}/zonic/Duo_Flex/Duo_Flex.usdz`,
                factName: "FLEX DUO",
                facts: {
                    "Abmessung": "H: 179 cm, B:  83 cm, T:  184 cm",
                    "Gewicht": "430kg",
                },
                accordionFacts: commmonZonicAccordionFacts,
                animationName: "Duo_Flex_Anim_0",
                animatioDuration: 1100,
                animatioDurationEnd: 800,
            },
        ]
    },
];

export const getModelById = (id: number): (ZonicModel|null) => {
    for (let index = 0; index < ZONIC_MODELS.length; index++) {
        const element = ZONIC_MODELS[index];
        for (let index = 0; index < element.models.length; index++) {
            const model = element.models[index];
            if(model.id === id) return model;
        }
    }
    return null;
}